module.exports = __webpack_public_path__ + "static/media/Golden.38d4e2c6.png";